var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cur_item
    ? _c(
        "div",
        { staticClass: "tg-restaurants" },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.is_load, rounded: "sm" } },
            [
              _vm.organizations.length
                ? _c(
                    "b-tabs",
                    { attrs: { pills: "", card: "", vertical: "" } },
                    _vm._l(_vm.organizations, function (organization, index) {
                      return _c(
                        "b-tab",
                        {
                          key: "org_" + organization.id,
                          attrs: { active: index === 0 },
                          on: {
                            click: function ($event) {
                              return _vm.selectOrganization(organization)
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          organization.title ||
                                            organization.name
                                        ) +
                                        "\n                    "
                                    ),
                                    _vm.loading_org_id === organization.id
                                      ? _c("b-spinner", {
                                          attrs: { small: "", type: "grow" },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _vm.getRestaurantsByOrganization(organization.id)
                            .length
                            ? _c(
                                "div",
                                _vm._l(
                                  _vm.getRestaurantsByOrganization(
                                    organization.id
                                  ),
                                  function (restaurant) {
                                    return _c(
                                      "div",
                                      {
                                        key: "rest_" + restaurant.id,
                                        staticClass:
                                          "list-group-item d-flex align-items-center justify-content-between",
                                      },
                                      [
                                        _c("div", [
                                          _c("div", { staticClass: "fw-600" }, [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  restaurant.title ||
                                                    restaurant.name
                                                ) +
                                                "\n                            "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "small",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "\n                                ID: " +
                                                  _vm._s(restaurant.id) +
                                                  "\n                            "
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "custom-control custom-switch",
                                          },
                                          [
                                            _c("input", {
                                              staticClass:
                                                "custom-control-input",
                                              attrs: {
                                                id: "tg-rest-" + restaurant.id,
                                                type: "checkbox",
                                              },
                                              domProps: {
                                                checked:
                                                  _vm.isRestaurantEnabled(
                                                    restaurant.id
                                                  ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.toggleRestaurant(
                                                    restaurant,
                                                    $event.target.checked
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("label", {
                                              staticClass:
                                                "custom-control-label",
                                              attrs: {
                                                for: "tg-rest-" + restaurant.id,
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _c("div", { staticClass: "text-muted p-3" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.__t("NO_DATA")) +
                                    "\n                "
                                ),
                              ]),
                        ]
                      )
                    }),
                    1
                  )
                : _c("div", { staticClass: "text-muted p-3" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.__t("NO_DATA")) +
                        "\n        "
                    ),
                  ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }